/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Features_Desk_AgoInputs */

const en_features_desk_ago = /** @type {(inputs: Features_Desk_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min ago`)
};

const pl_features_desk_ago = /** @type {(inputs: Features_Desk_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min temu`)
};

/**
* | output |
* | --- |
* | "{minutes} min ago" |
*
* @param {Features_Desk_AgoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_desk_ago = /** @type {((inputs: Features_Desk_AgoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Desk_AgoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_desk_ago(inputs)
	return en_features_desk_ago(inputs)
});